import { Modal } from 'antd';
import { useModalStore } from './modal-store';

/** Renders the store-driven modal with Ant Modal; custom footers from callers are passed straight through. */
export function ModalHost() {
  const spec = useModalStore((s) => s.modal);
  const close = useModalStore((s) => s.close);
  return (
    <Modal
      open={Boolean(spec)}
      title={spec?.title}
      width={spec?.large ? 900 : 560}
      footer={spec ? (spec.footer ?? undefined) : null}
      onCancel={close}
      onOk={close}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
      destroyOnHidden
      mask={{ closable: true }}
      keyboard
      className={spec?.large ? 'modal modal-lg' : 'modal'}
    >
      {spec?.body}
    </Modal>
  );
}
